<div *ngIf="industryDescriptions$ | async as descriptions">
  <p-panel header="Industry Descriptions" styleClass="drill-down-section-header" [toggleable]="true">
    <div *ngIf="hasMultipleDatabases">
      <span class="ey-float-label">
        <select
          class="drill-down-dropdown form-select"
          #industryDatabasesSelect
          [ngModel]="industryDescriptionsSelectedDatabaseId$ | async"
          (change)="onIndustryDescriptionsDatabaseChange(industryDatabasesSelect.value)"
          appLabelFloat
        >
          <option *ngFor="let database of databases" [value]="database.id">
            {{ database.name }}
          </option>
        </select>
        <label>Database Source</label>
      </span>
    </div>
    <div>
      <p-table [value]="descriptions" styleClass="industry-descriptions-table" [paginator]="true" [rows]="20" [alwaysShowPaginator]="false">
        <ng-template pTemplate="body" let-description>
          <tr class="industry-description-row">
            <td>{{ description }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-panel>
</div>
